var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.nomemodal,"ok-only":"","hide-header-close":"","scrollable":"","title":"Política de Privacidade"}},[_c('b-row',{domProps:{"innerHTML":_vm._s(_vm.texto)}},[_vm._v(" "+_vm._s(_vm.texto)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }